import { ROUTER_PATHS } from 'src/paths';
import type { CareerHubBrand, CareerHubCountry } from 'src/types';

import translations from './.vocab';
import { getTranslations } from './translations';

const t = getTranslations(translations);

export interface MetaDataInput {
  page: string;
  groupTitle?: string;
  threadTitle?: string;
  absoluteUrl: string;
  language: string;
  countryCode?: CareerHubCountry;
  brand: CareerHubBrand;
}

export interface MetaData {
  title: string;
  description: string;
  absoluteUrl: string;
}

const MAX_TITLE_LENGTH = 39;

const getThreadTitle = (threadTitle: string = ''): string => {
  if (threadTitle.length < MAX_TITLE_LENGTH) {
    return threadTitle;
  }
  return `${threadTitle.substring(0, MAX_TITLE_LENGTH)}...`;
};

export const getMetaData = ({
  page,
  groupTitle,
  threadTitle,
  absoluteUrl,
  language,
  countryCode,
  brand,
}: MetaDataInput): MetaData => {
  const absoluteUrlWithoutQueryParams = absoluteUrl.split('?')[0];
  const brandNames: Record<CareerHubBrand, string> = {
    seek: 'SEEK',
    jobsdb: 'Jobsdb',
    jobstreet: 'Jobstreet',
  };
  const brandName = brandNames[brand];

  switch (page) {
    case ROUTER_PATHS.communityHome:
      return {
        title: t(language, 'communityTitle', { brandName }),
        description: t(language, 'communityDescription'),
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityGroups:
      return {
        title: t(language, `communityGroupsTitle-${countryCode}`, {
          brandName,
        }),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityGroupsDetails:
      return {
        title: t(language, '{groupTitle}', { groupTitle, brandName }),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    case ROUTER_PATHS.communityThreadDetails:
      return {
        title: t(language, '{threadTitle}', {
          threadTitle: getThreadTitle(threadTitle),
          brandName,
        }),
        description: '',
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
    default:
      return {
        title: t(language, 'communityTitle', { brandName }),
        description: t(language, 'communityDescription'),
        absoluteUrl: absoluteUrlWithoutQueryParams,
      };
  }
};
